import React from 'react';

import img1Img from './images/img_01.png';
import img2Img from './images/img_02.png';
import img3Img from './images/img_03.png';
import img4Img from './images/img_04.png';

import { BGWrap, Btn } from './styled';

function SignContractorInterviewEvent() {
  return (
    <>
      <BGWrap width={710} height={1583} imgUrl={img1Img} />
      <BGWrap width={710} height={1528} imgUrl={img2Img} />
      <BGWrap width={710} height={2391} imgUrl={img3Img}>
        <Btn href="https://pro.dabangapp.com/sign/receipt/all" target="_blank" rel="noreferrer noopener" />
      </BGWrap>
      <BGWrap width={710} height={1590} imgUrl={img4Img} />
    </>
  );
}

export default SignContractorInterviewEvent;
